module.exports = __webpack_public_path__ + "img/auslagern.f11b730b.svg";